var render = function (_h,_vm) {var _c=_vm._c;return _c('picture',_vm._g({class:['Pic', _vm.data.class, _vm.data.staticClass]},_vm.listeners),[_vm._l((_vm.$options.sources(_vm.props)),function(ref){
var format = ref[0];
var formatSrc = ref[1];
var formatType = ref[2];
return _c('source',{key:format,attrs:{"srcset":formatSrc,"type":formatType}})}),_c('img',_vm._b({attrs:{"alt":_vm.props.alt,"src":_vm.$options.srcAbs(_vm.props.src)}},'img',_vm.data.attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }